/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { EntityDxpUserMeOrganisation } from '../../Services/console';

/**
 * Get a generated organisation path to the chosen screen.
 * @param {string} screenPath The web path for the screen within the organisation (must start with '/').
 * @param {boolean} substituteId Substitute :tenant with the real ID.
 * @export
 * @returns {string} A generated organisation path for the chosen screen.
 */
export const getOrganisationPath = (screenPath: string, substituteId?: boolean): string => {
  if (substituteId) {
    // Console service
    const { tenant } = useConsoleServiceStore.getState();
    const { tenantReferenceId } = tenant as EntityDxpUserMeOrganisation;

    return `/organization/${tenantReferenceId}${screenPath}`;
  }

  return `/organization/:tenant${screenPath}`;
};
